import { http } from './api'

// Editable site settings (contact info, …) served from the backend.
// Contacts is a single object: { emails[], phones[], address{locale}, mapEmbedUrl }.
// Cached after the first fetch; pass `true` to force a refresh.
export default {
  namespaced: true,

  state: () => ({
    contacts: null,
    loaded: false,
    loading: false,
    error: null
  }),

  getters: {
    contacts: state => state.contacts
  },

  mutations: {
    setContacts(state, value) { state.contacts = value; state.loaded = true },
    setLoading(state, value) { state.loading = value },
    setError(state, error) { state.error = error }
  },

  actions: {
    async fetchContacts({ commit, state }, force = false) {
      if (state.loaded && !force) return
      commit('setLoading', true)
      commit('setError', null)
      try {
        const { data } = await http.get('/api/v1/settings/contacts')
        commit('setContacts', data.data)
      } catch (err) {
        commit('setError', err.message || 'Network error')
      } finally {
        commit('setLoading', false)
      }
    }
  }
}
